import styled from 'styled-components'

export const StyledExchangeBtn = styled.button`
  background: ${({ theme }) => theme.colors.btnPrimary};
  border-radius: 48px;
  border: none;
  outline: none;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  padding: 12px 0;
  width: 100%;
  margin-top: 20px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  &.disabled {
    background: ${({ theme }) => theme.colors.btnPrimaryDisabled};
    cursor: not-allowed;
  }
  img {
    width: 16px;
    height: 16px;
  }
`
